import React, { useState, useEffect } from 'react';
import SwipeableDrawer from 'jd-library/SwipeableDrawer';
import UploadFromUrl from '../UploadOptions/upload-from-url/UploadFromUrl';
import ShowUploadLibraryImage from '../UploadOptions/UploadLibraryImages/UploadLibraryImage';
import { openCamera, openGallery } from "../../pages/add-edit-item/appUtils/AppUtils";
import { connect } from 'react-redux';
import { onImageUploadFromAppSuccess } from '../Utills';

const options = [{
    icon: ' icon-Image',
    text: 'Upload from Gallery',
    value: 'gallery'
}, {
    icon: 'icon-cameraNew',
    text: 'Camera',
    value: 'camera'
},
{
    icon: 'icon-Library',
    text: 'Upload from Library',
    value: 'library'
},
{
    icon: 'icon-Link',
    text: 'Upload from URL',
    value: 'url'
}
];

let isMobileApp = false;

const UploadImageOptions = props => {
    const [uploadFromUrl, toggleUploadFromUrl] = useState(false);
    const [showUploadFromLibrary, updateShowUploadFromLibrary] = useState(false);
    const [swipeDrawerOptions, updateSwipeDrawerOptions] = useState(options);

    useEffect(() => {
        let drawerOption = [...options];
        if (!props.deviceData.isAndroidApp || (window.jdInterface && window.jdInterface.openNativeFileChooser) || props.type == 'itemCategory') {
            const cameraIndex = drawerOption.findIndex((cur) => cur.value === "camera");
            if (cameraIndex != -1) {
                drawerOption.splice(cameraIndex, 1);
            }
        }
        if (props.type == 'addEditItem') {
            const libraryIndex = drawerOption.findIndex((cur) => cur.value === "library");
            if (libraryIndex != -1) {
                drawerOption.splice(libraryIndex, 1);
            }
        }
        updateSwipeDrawerOptions(drawerOption);
        isMobileApp = props.deviceData.isAndroidApp || props.deviceData.isIphoneApp;
    }, [])

    const onloadResult = (res) => {
        if (res.data) {
            let _data = JSON.parse(res.data)[0];
            if (_data.status === "success") {
                //props.updateProductImage({ imageUrl: _data.imgURL, createdfrom: 'mobileApp' });
                let variantId = props.variantId;
                onImageUploadFromAppSuccess(res, props, variantId);
            } else {
                props.onHidden();
                //Waiting to Upload
                console.log("Error while uploading: ", res.data);
            }
        }else if(res.error=="invalidFile"){
            props.onHidden();
            props.showToastMessage({
				showToastMessage: true,
				message: 'Only JPG, JPEG & PNG Files are Supported',
				duration: 5000
			});
        }else {
            //Waiting to Upload
            console.log("waiting to upload");
        }
    }

    const cameraOptions = () => {
        openCamera({
            index: 0,
            imgUploadUrl: props.imgUploadUrl,
            callback: (res) => {
                onloadResult(res);
            }
        });
    }

    const galleryOptions = () => {
        openGallery({
            index: 0,
            imgUploadUrl: props.imgUploadUrl,
            callback: (res) => {
                onloadResult(res);
            }
        });
    }

    const onOptionClick = (e, option) => {
        if (option.value == 'url') {
            toggleUploadFromUrl(true);
        } else if (option.value == 'library') {
            updateShowUploadFromLibrary(true);
        } else if (option.value == 'camera') {
            cameraOptions();
        } else if (option.value == "gallery") {
            if (isMobileApp && !props.deviceData.isIphoneApp && !window.jdInterface.openNativeFileChooser) {
                galleryOptions();
            } else {
                props.onClickGallery();
            }
        }
    }

    return (
        <>
            <SwipeableDrawer
                hideCross={true}
                horizontalBar={true}
                onHidden={props.onHidden}
                drawerOptions={swipeDrawerOptions}
                onClick={onOptionClick}
                className={'image-select-options'}
            />
            {uploadFromUrl ? <UploadFromUrl type={props.type} onHidden={() => { toggleUploadFromUrl(false); props.onHidden(); }} updateProductImage={props.updateProductImage} /> : null}
            {showUploadFromLibrary ? <ShowUploadLibraryImage type={props.type} uploadLibrary={true} onHidden={() => { updateShowUploadFromLibrary(false); props.onHidden(); }} updateProductImage={props.updateProductImage} /> : null}
        </>
    );
}

const mapStateToProps = state => {
    return {
        deviceData: state.deviceData
    };
};

export default connect(mapStateToProps, null)(UploadImageOptions);